import { render } from "./ExpressPayment.vue?vue&type=template&id=ba7afa96&scoped=true"
import script from "./ExpressPayment.vue?vue&type=script&lang=js"
export * from "./ExpressPayment.vue?vue&type=script&lang=js"

import "./ExpressPayment.vue?vue&type=style&index=0&id=ba7afa96&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7afa96"]])

export default __exports__